import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div id='top' className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only rounded-lg bg-orange px-4 py-3 font-semibold text-navy focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
